import styled from "styled-components"

export const BaseButton = styled.button`
  display: flex;
  font-family: "Rubik", sans-serif;

  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1.25rem 1.5rem;
  font-size: 1rem;
  color: #ffffff;
  font-weight: 500;
  width: 15;
  height: 3.1875rem;
  border: none;
  outline: none;
  cursor: pointer;
  border-radius:5px;
  transition: all 0.3s ease;
  background: #1B6EF3;
  box-shadow: 0px 0.5625rem 0.875rem rgba(20, 52, 167, 0.25);
  &:hover {
    transition: all 0.3s ease;
    box-shadow: none;
  }
  @media screen and (max-width: 1000px) {
    width: 100%;
    padding: 1.25rem 1.5rem;
    width: 100%;
    height: 51px;
  }
`
